import InputBase from '@mui/material/InputBase';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { InboxFilter } from '../../../../sic-lib/types/InboxTypes';

export default function NewRecentFilterOptionsSearchInput({ compState, setCompState }: Props) {
    const { classes } = useStyles();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCompState({
            filter: {
                ...compState.filter,
                search: event.currentTarget.value,
            },
        });
    };

    return (
        <InputBase
            autoFocus={true}
            placeholder="Search &amp; Filter"
            inputProps={{ 'aria-label': 'Search messages' }}
            value={compState.filter.search}
            onChange={handleChange}
            className={classes.input}
        />
    );
}

interface Props {
    compState: InboxFilter;
    setCompState: React.Dispatch<Partial<InboxFilter>>;
}

const useStyles = makeStyles()({
    input: {
        width: '100%',
    },
});
